import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../context/LangContext";
import { ROUTES } from "../constants";
import Button from "../components/ui/Button";

export default function NotFoundPage() {
  const { t } = useLang();
  return (
    <>
      <Helmet>
        <title>404 — EccoFarm</title>
      </Helmet>

      <div className="min-h-screen bg-navy flex flex-col items-center justify-center text-center px-5">
        {}
        <p
          className="font-syne font-extrabold text-teal/10 leading-none select-none mb-6"
          style={{ fontSize: "clamp(6rem, 25vw, 18rem)" }}
        >
          404
        </p>

        <h1 className="font-syne text-white font-bold text-2xl md:text-3xl mb-3 -mt-8">
          {t.notFound.title}
        </h1>
        <p className="text-silver text-sm md:text-base mb-8 md:mb-10 max-w-sm">
          {t.notFound.subtitle}
        </p>

        <Link to={ROUTES.HOME}>
          <Button
            variant="primary"
            size="lg"
            iconLeft={<ArrowLeft size={18} />}
          >
            {t.notFound.cta}
          </Button>
        </Link>
      </div>
    </>
  );
}
